// extracted by mini-css-extract-plugin
module.exports = {"card":"article-card-with-image_card__z2C51"};